export default function Pagination({ page, total, onChange }) {
  if (total <= 1) return null;
  const btn = "grid size-10 place-items-center rounded-lg border font-semibold transition focus-visible:outline-2 focus-visible:outline-glow";
  return (
    <nav aria-label="Pagination" className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button disabled={page === 1} onClick={() => onChange(page - 1)} className={`${btn} border-line disabled:opacity-40`} aria-label="Previous page">‹</button>
      {Array.from({ length: total }, (_, i) => i + 1).map((n) => (
        <button
          key={n}
          onClick={() => onChange(n)}
          aria-current={n === page ? "page" : undefined}
          className={`${btn} ${n === page ? "border-glow bg-glow text-ink" : "border-line hover:border-glow"}`}
        >
          {n}
        </button>
      ))}
      <button disabled={page === total} onClick={() => onChange(page + 1)} className={`${btn} border-line disabled:opacity-40`} aria-label="Next page">›</button>
    </nav>
  );
}
